function submitWarranty(registrationform) {
  var selectedProducts = "";

  for (var i = 0; i < registrationform.find('input[name$="product"]').length; i++){
    if (registrationform.find('input[name$="product"]')[i].checked){
      selectedProducts += registrationform.find('input[name$="product"]')[i].value + " " + ", ";
    }
  }
  
  const registrationData = {
    method: "POST",
    headers: {
      accept: "text/html", 
      "content-type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      data: JSON.stringify({
        token: "XUrgPf",
        event: "Product Registration Submission",
        customer_properties: {
          $email: registrationform.find('input[name$="registration_email"]').val(),
          $first_name: registrationform.find('input[name$="registration_firstname"]').val(),
          $last_name: registrationform.find('input[name$="registration_lastname"]').val()
        },
        properties: {
          customer_email: registrationform.find('input[name$="registration_email"]').val(),
          customer_first_name: registrationform.find('input[name$="registration_firstname"]').val(),
          customer_last_name: registrationform.find('input[name$="registration_lastname"]').val(),
          customer_gender: registrationform.find(".js-gender input[type='radio']:checked").val(),
          customer_iam: registrationform.find('select[name$="registration_iam"]').val(),
          product_serial_number: registrationform.find('input[name$="registration_serialnumber"]').val() !== '' ? registrationform.find('input[name$="registration_serialnumber"]').val() : '',
          customer_selected_products: selectedProducts
        }
      })
    })
  };

  fetch('https://a.klaviyo.com/api/track', registrationData)
  .then(response => response.json())
  .then(response => {
    if(response == 1){
      navigateForms('confirmation');
    }else if(response === 0){
      if($('.c-stick-warranty__container .general-error-message').hasClass('u-display-none')){
        $('.c-stick-warranty__container .general-error-message').removeClass('u-display-none');
      }
    }
  })
  .catch(err => {
    if($('.c-stick-warranty__container .general-error-message').hasClass('u-display-none')){
      $('.c-stick-warranty__container .general-error-message').removeClass('u-display-none');
    }
  });
}

function subscribeKlaviyoList(registrationform){
  fetch("https://a.klaviyo.com/client/subscriptions/?company_id=XUrgPf", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "revision": '2024-10-15'
    },
    body: JSON.stringify({
      "data": {
        "type": "subscription",
        "attributes": {
          "custom_source": "product_registration",
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": registrationform.find('input[name$="registration_email"]').val(),
                "properties": {
                  "Language": "English - United States"
                }
              }
            }
          }
        },
        "relationships": {
          "list": {
            "data": {
              "type": "list",
              "id": "TCk9U5"
            }
          }
        }
      }
    })
  })
  .then((res) => {
    console.log(res);
  })
  .catch((error) => {
      console.error(error);
  });
}

function navigateForms(loc){
  switch(loc){
    case 'home':
      $('#registration').removeClass('u-display-none');
      if(!$('#registrationconfirmation').hasClass('u-display-none')) {
          $('#registrationconfirmation').addClass('u-display-none');
      }
      break;
    case 'confirmation':
      if(!$('#registration').hasClass('u-display-none')) {
          $('#registration').addClass('u-display-none');
      }
      $('#registrationconfirmation').removeClass('u-display-none');
      break;
    default:
      console.log('Bad Nav');
  }
  //Scroll to top
  $('html, body').stop().animate({
      'scrollTop': $('#primary').offset().top - $('.header-wrapper').height()
  }, 800);
}

function initRegistrationForm(){
  $('.c-registration-submit').on('click', function(ele){
    ele.preventDefault();
    const form = $('#registration');
    //let genderSelected = false;
    let productSelected = false;
    let ageConsentSelected = false;

    //if($('.c-stick-warranty__container').find('.js-gender').length > 0){
      //genderSelected = $('.js-gender').find('input[name*=registration-gender]').is(':checked');
      //if(!genderSelected){
        //$('#gender-selection-error').css('display', 'block');
        //$("#gender-selection-error").html(
          //'<div class="alert alert-error"> ' + window.Resources.GENDER_ERROR_MSG + ' </div>'
        //);
        //if($('.c-stick-warranty__container .required-values-error').hasClass('u-display-none')) {
          //$('.c-stick-warranty__container .required-values-error').removeClass('u-display-none');
        //}
      //}
    //}

    if($('.c-stick-warranty__container').find('.js-product-selection').length > 0){
      productSelected = $('.js-product-selection').find('input[name*=product]').is(':checked');
      if(!ageConsentSelected){
        $('#product-selection-error').css('display', 'block');
        $("#product-selection-error").html(
          '<div class="alert alert-error"> ' + window.Resources.AGE_CONSENT_MSG + ' </div>'
        );
        if($('.c-stick-warranty__container .required-values-error').hasClass('u-display-none')) {
          $('.c-stick-warranty__container .required-values-error').removeClass('u-display-none');
        }
      }
    }
    
    if($('.c-stick-warranty__container').find('.js-age-consent').length > 0){
      ageConsentSelected = $('.js-age-consent').find('input[name*=age_consent]').is(':checked');
      if(!ageConsentSelected){
        $('#age-consent-error').css('display', 'block');
        $("#age-consent-error").html(
          '<div class="alert alert-error"> ' + window.Resources.AGE_CONSENT_MSG + ' </div>'
        );
        if($('.c-stick-warranty__container .required-values-error').hasClass('u-display-none')) {
          $('.c-stick-warranty__container .required-values-error').removeClass('u-display-none');
        }
      }
    }

    if(form.valid() & ageConsentSelected & productSelected){
      if(!$('.c-stick-warranty__container .general-error-message').hasClass('u-display-none')) {
        $('.c-stick-warranty__container .general-error-message').addClass('u-display-none');
      }
      if(!$('.c-stick-warranty__container .required-values-error').hasClass('u-display-none')) {
        $('.c-stick-warranty__container .required-values-error').addClass('u-display-none');
      }

      submitWarranty(form);

      if($('.c-stick-warranty__container').find('.registration-consent').length > 0){
        const selectionMade = $('.registration-consent').find('input[name*=marketing_consent]').is(':checked');
        if(selectionMade){
          subscribeKlaviyoList(form);
        }
      }
    }
  });
}

// Initialize warranty form
window.addEventListener("DOMContentLoaded", function(){
  initRegistrationForm();
});